import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { HashRouter, Route } from "react-router-dom";
import "react-notifications-component/dist/theme.css";
import ReactNotification from "react-notifications-component";
const app = (
  <HashRouter>
    <ReactNotification />
    <App />
  </HashRouter>
);

ReactDOM.render(app, document.getElementById("root"));
serviceWorker.unregister();
